var chunkToChildrenMap = {
	"73928": [
		85181,
		54511,
		67733,
		25653,
		75711,
		18705,
		9105
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));